import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useArchivedProjects } from '@/features/projects/projects.hooks';
import ProjectTable from '@/features/projects/projects.table';

export const ArchivedProjectsPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const resource = useArchivedProjects();

  return (
    <Panel {...panelProps}>
      <ProjectTable basePath={basePath} {...resource} />
    </Panel>
  );
};
